var React = require('react');

function TotalNumberOfEmployees (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"42.07 46.43 19.78 33.7 19.78 2.44 42.07 15.16 42.07 46.43","fill":"#9bbae7","key":0}),React.createElement("polygon",{"points":"36.48 49.55 4.91 31.32 4.91 0.06 36.48 18.28 36.48 49.55","fill":"#eeeef4","key":1}),React.createElement("polygon",{"points":"15.18 31.37 11.1 29 11.1 20.46 15.18 22.83 15.18 31.37","fill":"#2c2a43","key":2}),React.createElement("polygon",{"points":"22.36 35.51 18.28 33.15 18.28 19.28 22.36 21.65 22.36 35.51","fill":"#1e80eb","key":3}),React.createElement("polygon",{"points":"29.54 39.77 25.46 37.41 25.46 18.07 29.54 20.43 29.54 39.77","fill":"#9bbae7","key":4})]);
}

TotalNumberOfEmployees.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 50 50"};

module.exports = TotalNumberOfEmployees;

TotalNumberOfEmployees.default = TotalNumberOfEmployees;
